import { render, staticRenderFns } from "./LegendView.vue?vue&type=template&id=4e153650&scoped=true&"
import script from "./LegendView.vue?vue&type=script&lang=js&"
export * from "./LegendView.vue?vue&type=script&lang=js&"
import style0 from "./LegendView.vue?vue&type=style&index=0&id=4e153650&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e153650",
  null
  
)

export default component.exports